import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import "@/App.css";
import LenisProvider from "@/lib/LenisProvider";
import { AuthProvider } from "@/lib/auth";
import { trackVisit } from "@/lib/analytics";

import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";

import Home from "@/pages/Home";
import Inventory from "@/pages/Inventory";
import VehicleDetail from "@/pages/VehicleDetail";
import Compare from "@/pages/Compare";
import RequestForm from "@/pages/RequestForm";
import Warranty from "@/pages/Warranty";
import FAQs from "@/pages/FAQs";
import About from "@/pages/About";
import Track from "@/pages/Track";
import Partner from "@/pages/Partner";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function AnalyticsTracker() {
  const { pathname } = useLocation();
  useEffect(() => { trackVisit(pathname); }, [pathname]);
  return null;
}

function Shell({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <Navbar />
      <main>{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppFloat />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LenisProvider>
            <ScrollToTop />
            <AnalyticsTracker />
            <Toaster theme="dark" position="bottom-right" toastOptions={{
              style: { background: "#0F172A", border: "1px solid rgba(197,160,89,0.4)", color: "#fff" },
            }}/>
            <Shell>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/inventory" element={<Inventory />} />
                <Route path="/vehicle/:slug" element={<VehicleDetail />} />
                <Route path="/compare" element={<Compare />} />
                <Route path="/reserve" element={<RequestForm kind="reserve" />} />
                <Route path="/quote" element={<RequestForm kind="quote" />} />
                <Route path="/finance" element={<RequestForm kind="finance" />} />
                <Route path="/fleet" element={<RequestForm kind="fleet" />} />
                <Route path="/import" element={<RequestForm kind="import" />} />
                <Route path="/contact" element={<RequestForm kind="contact" />} />
                <Route path="/warranty" element={<Warranty />} />
                <Route path="/faqs" element={<FAQs />} />
                <Route path="/about" element={<About />} />
                <Route path="/track" element={<Track />} />
                <Route path="/partner" element={<Partner />} />
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
              </Routes>
            </Shell>
          </LenisProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
